import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  { path: '', redirectTo: 'Login', pathMatch: 'full' },
  { path: 'Login', component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: 'homepage',
    loadChildren: () => import('./components/homepage/homepage.module').then(m => m.HomepageModule),
    canActivate: [AuthGuard],
    data: { roles: ['REP_POB', 'REP_ALL','REP_KYC'] } // Accessible by REP_POB and REP_ALL
  },
  {
    path: 'UserKycDashboard',
    loadChildren: () => import('./components/user-kyc/user-kyc.module').then(m => m.UserKycModule),
    canActivate: [AuthGuard],
    data: { roles: ['USER_KYC'] } // Accessible by USER_KYC
  }

]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
